import { Variant } from './model';

export const TYPOGRAPHY_VARIANT_DEFAULT: Variant = 'body';
